module.exports = __webpack_public_path__ + "static/media/icon_error.539647fb.svg";